/** @format */

export * from './accordion.module';
